import * as angular from "angular";
import {BringozApi, BringozApiAction} from "../../persistence-layer/models/bringoz-api.model";

export class RuleEngineRequestsService {
  constructor(private $ruleEngine, private ruleEngineAPI: BringozApi) {
  }

  // ******************************
  // External methods
  // ******************************

  getEvents() {
    const api: BringozApiAction = this.ruleEngineAPI.actions.getEvents;
    return this.$$call(api, {}, {}, {});
  }

  getEntityFilters(entity: string) {
    const api: BringozApiAction = this.ruleEngineAPI.actions.getEntityFilters;
    return this.$$call(api, {
      entity: entity
    }, {}, {});
  }

  getEntityActions(entity: string) {
    const api = this.ruleEngineAPI.actions.getEntityActions;
    return this.$$call(api, {
      entity: entity
    }, {}, {});
  }

  getEntitySubtypes(entity: string) {
    const api: BringozApiAction = this.ruleEngineAPI.actions.getEntitySubtypes;
    return this.$$call(api, {entity: entity}, {}, {});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(apiCall, params, data, options) {
    return this.$ruleEngine().$call(apiCall, params, data, options);
  }

  // private $$$call(apiCall, params, data, options, ruleId) {
  //   return this.$rules(ruleId).$call(apiCall, params, data, options);
  // }
}

angular
  .module('bringoz.admin.ruleEngine')
  .service('ruleEngineRequestsService', RuleEngineRequestsService);
